import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const styles = {
  button: (visible) => ({
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    width: '46px',
    height: '46px',
    borderRadius: '50%',
    background: 'rgba(15, 23, 42, 0.8)',
    backdropFilter: 'blur(8px)',
    border: '1px solid var(--accent)',
    color: 'var(--accent)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: 100,
    opacity: visible ? 1 : 0,
    transform: visible ? 'translateY(0)' : 'translateY(20px)',
    transition: 'opacity 0.3s, transform 0.3s, box-shadow 0.3s',
    boxShadow: visible ? '0 0 20px rgba(34, 197, 94, 0.3)' : 'none',
  }),
};

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisible = () => {
      if (window.scrollY > 400) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisible);
    return () => window.removeEventListener('scroll', toggleVisible);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button 
      style={styles.button(visible)} 
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className="scroll-to-top"
    >
      <ChevronUp size={24} strokeWidth={2.5} />
    </button>
  );
}
